module.exports = __webpack_public_path__ + "img/85ne.419025d4.svg";